/*
 * @Author: your name
 * @Date: 2021-03-03 18:18:05
 * @LastEditTime: 2022-02-18 10:59:11
 * @LastEditors: zhaozhuo
 * @Description: In User Settings Edit
 * @FilePath: \edc-mobile-web\src\request\index.js
 */
/**
 * api 接口的统一出口
*/
import research from './api/research'
import recruitment from './api/recruitment'
import visit from './api/visit'
import visitForm from './api/visitForm'
import formData from './api/formData'
import itemGroup from './api/itemGroup'
import canlender from './api/canlender'
import file from './api/file'
import user from './api/user'
import center from './api/center'
import subject from './api/subject'
import systemConfig from './api/systemConfig'
export default {
	research,
	recruitment,
	visit,
	visitForm,
	formData,
	itemGroup,
	canlender,
	file,
	user,
	center,
	subject,
	systemConfig
}
